export default __webpack_public_path__ + "static/media/tv4.c7bd525c.jpeg";